import Git from '../assets/git.jpg'
import BlogImage from '../assets/blog-image.jpg'
export const posts = [
    {
        id: 0,
        featured: false,
        title: 'Leetcode Problem: Move Zeros',
        date: 'November 2022',
        topic: 'Leetcode',
        ContentType:"text/html",
        excerpt: "Given an integer array nums, move all 0's to the end of it while maintaining the relative order of the non-zero elements.",
        cover: BlogImage,
        author: 'Sumaiya Meem',
        link: 'https://dev.to/stmeem/leetcode-problem283-move-zeros-57fn'
    },
    {
        id: 1,
        featured: true,
        title: 'Get Started with React Project On Windows',
        date: 'May 2020',
        topic: 'React',
        excerpt: 'React is the most popular Javascript framework for building user interfaces.',
        cover: Git,
        author: 'Sumaiya Meem',
        link: 'https://medium.com/@sumaiyatasmeem/how-to-get-started-with-react-project-on-windows-and-deploy-it-on-github-pages-175dad0aae9c',

    }]